import { getPreferredPhone, useGetAllContacts } from "@api/contactService";
import { useEffect, useState } from "react";
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import ObjectIndex from "@components/objects/ObjectIndex";
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { useGetAllUsers } from "@api/userService";
import { Alert, Autocomplete, AutocompleteOption, Button, Checkbox, Grid, ListItemContent, ListItemDecorator, Stack } from "@mui/joy";
import { Link } from "react-router-dom";
import { ContextualHelp } from "@components/ContextualHelp";
import { countries, userRoles } from "@utils/selectOptions";
import Subheader from "@components/layout/Subheader";
import { FormProvider, useForm } from "react-hook-form";
import { ObjectPrimaryInfoEdit } from "@components/objects/ObjectPrimaryInfoEdit";
import ObjectColumn from "@components/objects/ObjectColumn";
import { useTenant } from "@providers/TenantProvider";
import { apiUrl, authenticatedApi, cookieDomain, getAccessToken, tenantUnawareApiUrl } from "api";
import toast from "react-hot-toast";
import { useGetAllCoordinatingPrograms } from "@api/coordinatingProgramService";
import MaestroLoader from "@components/MaestroLoader";
import Uploady, { useBatchAddListener, useBatchFinishListener, useItemFinishListener, useRequestPreSend, useUploady } from "@rpldy/uploady";
import WarningDialog from '@components/dialogs/WarningDialog';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import GppBadRoundedIcon from '@mui/icons-material/GppBadRounded';
import { CONSTANT_CONTACT_ID, MAILCHIMP_ID } from "config";
import Cookies from "js-cookie";
import { useDocumentTitle } from "@uidotdev/usehooks";

const CoordinatingProgramsField = ({data, setValue}) => {
    const [checked, setChecked] = useState(/*data?.conductors ??*/ []);
    const {
        // isPending,
        isLoading,
        isError,
        error,
        data:programData,
        isFetching,
        isPreviousData,
    } = useGetAllCoordinatingPrograms(
        {per_page: '-1'},
        {
            retry: false,
        }
    );

    const programIsChecked = (id) => checked.find(cp => cp.id === id) ? true : false;
    const topLevelPrograms = programData?.data.filter(cp => cp.parent_id === null) ?? [];

    useEffect(() => {
        if(!programData?.data || !data?.conductors) {
            return;
        }

        let _checked = [];
        for(const cp of data.conductors) {
            const found = programData.data.find(p => p.id === cp.id);
            found && _checked.push(found);
        }

        setChecked(_checked);
    }, [programData]);

    const toOptions = (opts) => {
        return opts.map(option => ({
            label: option.name,
            value: option.id,
        }))
    }

    const onChange = (program, reason) => {
        const parentChecked = checked.filter(program => !program.parent_id);
                // setChecked(_checked);
                // setValue('conductors', _checked);


        if(!program) {
            // clear reason comes from the autocomplete so we know what was cleared
            if(reason === 'clear') {
                // const _checked = checked.filter(program => !program.parent_id);
                setChecked(parentChecked);
                setValue('conductors', parentChecked);
                // clear the selected values
            }
            return;
        }

        const newVal = !programIsChecked(program?.id);

        let _checked = [...parentChecked];
        if(newVal) {
            _checked.push(program);

            /*
            // todo: make sure it's not already
            if(program.parent_id && !programIsChecked(program.parent_id)) {
                _checked.push(topLevelPrograms.find(p => p.id === program.parent_id));
            }
            */
        } else {
            let ind = _checked.indexOf(program);
            ind !== -1 && _checked.splice(ind, 1);

            /*
            if(program.parent_id) {
                let parent = topLevelPrograms.find(p => p.id === program.parent_id);
                let parentInd = _checked.indexOf(parent);
                parentInd !== -1 && _checked.splice(parentInd, 1);
            }
            */
        }

        setChecked(_checked);
        setValue('conductors', _checked);
    }

    if(isLoading) {
        return <MaestroLoader/>
    }

    return <>
        {topLevelPrograms.map(parentProgram => {
            const secondaryPrograms = programData.data.filter(cp => cp.parent_id === parentProgram.id);
            return (
                <Box>
                    {/* <Tooltip title={secondaryPrograms.length > 0 ? 'This will be selected automatically when you select a program.' : ''}> */}
                    <Checkbox
                        value={parentProgram.id}
                        label={parentProgram.name}
                        // disabled={secondaryPrograms.length > 0}
                        // onChange={onChange}
                        onChange={()=>onChange(parentProgram)}
                        checked={programIsChecked(parentProgram.id)}
                    />
                    {/* </Tooltip> */}
                    {secondaryPrograms.length > 0 && (
                        <Box sx={{mt: 1, /*ml: 5*/ /*, maxHeight: '150px', overflowY: 'scroll'*/}}>
                            <Autocomplete
                                openOnFocus={true}
                                placeholder="Type to search"
                                options={secondaryPrograms}
                                value={checked ?? []}
                                onChange={(e,v,r)=>onChange(v,r)}
                                isOptionEqualToValue={(option) => {
                                    if(!Array.isArray(option)) {
                                        option = [option];
                                    }
                                    for(const o of option) {
                                        if(programIsChecked(o.id)) {
                                            return true;
                                        }
                                    }
                                    return false;
                                    //programIsChecked(option.id)
                                }}
                                getOptionLabel={(option) => {
                                    if(!Array.isArray(option)) {
                                        option = [option];
                                    }
                                    for(const o of option) {
                                        const findIt = secondaryPrograms.find(opt => opt.id === o.id);
                                        if(findIt) {
                                            return findIt.name
                                        }
                                    }
                                    return '';
                                }}
                                /*
                                renderOption={(props, option) => (
                                    <AutocompleteOption {...props}>
                                    <ListItemDecorator>
                                        <Checkbox checked={programIsChecked(option.id)} />
                                    </ListItemDecorator>
                                    <ListItemContent>
                                        {option.name}
                                    </ListItemContent>
                                    </AutocompleteOption>
                                )}
                                */
                                />
                        </Box>
                    )}
                </Box>
            )
        })}
    </>
}

const communityFields = [
    {
        name: 'general_info',
        label: false,
        type: 'info',
        content: <Typography sx={{fontSize: 'md', fontWeight: 'bold', mt: 0.5}}>General Information</Typography>
    },

    {
        name: 'name',
        label: 'Community Name',
        type: 'text',
        placeholder: 'Community Name...',
        config: {
            required: true,
        },
        content: (object) => (
            <Typography sx={{fontSize: 'sm', mt: 1}}>This will not change the URL you use to access Maestro.</Typography>
        )
    },
    {
        name: 'logo',
        type: 'file',
        label: 'Logo',
        scope: 'logo',
        showPending: true,
        url: (object) => object?.logo_url,
        /*
        content: (object) => (
            <Typography sx={{fontSize: 'sm', mt: 1}}>Logos will upload instantly.</Typography>
        )
        */
    },
    {name: 'url', label: 'Website', type: 'text', placeholder: 'e.g. https://tastytruffles.net'},
    {
        name: 'admin_email',
        label: 'Primary Email',
        type: 'email',
        placeholder: 'e.g. marsha@tastytruffles.net',
        config: {
            required: true,
        },
        content: (object) => (
            <Typography sx={{fontSize: 'sm', mt: 1}}>We will use this email for important account-related communications.</Typography>
        )
    },

    {
        name: 'location_info',
        label: false,
        type: 'info',
        content: <Typography sx={{fontSize: 'md', fontWeight: 'bold', mt: 0.5}}>Location Information</Typography>
    },
    {name: 'address', type: 'text', placeholder: 'e.g. 123 Main Street'},
    {name: 'address_2', label: <>Address <br/>(cont.)</>, type: 'text', placeholder: 'e.g. Suite A'},
    {
        name: 'country',
        type: 'select',
        options: countries,
        config: {
            required: true,
        },
    },
    {
        name: 'postal',
        label:<>Zip/<wbr/>Postal</>,
        type: 'text',
        placeholder: 'e.g. 61325',
        config: {
            required: true,
        },
    },
    {
        name: 'city',
        type: 'text',
        placeholder: 'e.g. MainStreet',
        config: {
            required: true,
        },
    },
    {
        name: 'state',
        label: 'State',
        type: 'text', // todo make this a dropdown
        placeholder: 'e.g. IL',
        config: {
            required: true,
        },
    },

    {
        name: 'demographic_info',
        label: false,
        type: 'info',
        content: <Typography sx={{fontSize: 'md', fontWeight: 'bold', mt: 0.5}}>Demographics (optional)</Typography>
    },
    {
        name: 'coordinating_programs',
        type: 'info',
        label: 'Coordinating Program',
        content: (data, setValue) => <CoordinatingProgramsField data={data} setValue={setValue} />,
    },
    {name: 'board_size', type: 'number', placeholder: 'e.g. 5'},
    {
        name: 'financial_structure',
        type: 'select',
        // placeholder: 'e.g. 5',
        options: [
            {label: 'City Employee', value: 'city'},
            {label: '501(c)(3)', value: '501c3'},
            {label: '501(c)(6)', value: '501c6'},
            {label: 'Other', value: 'other'},
        ],
    },
    {
        name: 'fiscal_year_start',
        type: 'select',
        // placeholder: 'e.g. 5',
        options: [
            {label: 'January', value: '01'},
            {label: 'February', value: '02'},
            {label: 'March', value: '03'},
            {label: 'April', value: '04'},
            {label: 'May', value: '05'},
            {label: 'June', value: '06'},
            {label: 'July', value: '07'},
            {label: 'August', value: '08'},
            {label: 'September', value: '09'},
            {label: 'October', value: '10'},
            {label: 'November', value: '11'},
            {label: 'December', value: '12'},
        ],
    },


    {
        type: 'submit',
        label: false,
        buttonLabel: 'Update Settings',
    },
];

const connectAccountRedirect = tenantUnawareApiUrl+'integrations/connect';
const connectableAccounts = {
    mailchimp: {
        name: 'Mailchimp',
        connectUrl: `https://login.mailchimp.com/oauth2/authorize?response_type=code&client_id=${MAILCHIMP_ID}&redirect_uri=${encodeURIComponent(connectAccountRedirect+'-mc')}`,
    },
    constant_contact: {
        name: 'Constant Contact',
        connectUrl: `https://oauth2.constantcontact.com/oauth2/oauth/siteowner/authorize?response_type=code&client_id=${CONSTANT_CONTACT_ID}&redirect_uri=${encodeURIComponent(connectAccountRedirect+'-cc')}`,
    },
};

function ConnectButton({type}) {
    const { tenant } = useTenant();

    /*
    // this is a temporary workaround to force the page to reload after we click the connect button
    // because those aren't tied into tanstack-query yet
    const [reloadOnFocus, setReloadOnFocus] = useState(false);
    useEffect(() => {
        window.addEventListener("focus", function(e) {
            console.log('window was focused', reloadOnFocus);
            if(reloadOnFocus) {
                window.location.reload();
            }
        }, false);

        document.addEventListener("visibilitychange", function(e) {
            console.log('window visibility changed');
            if(reloadOnFocus && !document.hidden) {
                window.location.reload();
            }
        }, false);
    }, []);
    */

    const onClick = () => {
        // setReloadOnFocus(true);

        // oauth spec only supports strict matching so we have to redirect to a tenant-unaware URL
        // we use this to correctly identify the tenant on the API
        Cookies.set('oauth-subdomain-redirect', tenant.subdomain, {
            domain: cookieDomain,
        });

        // window.location.href = connectableAccounts[type].connectUrl;
        console.log(connectableAccounts[type].connectUrl);
        let win = window.open(connectableAccounts[type].connectUrl, '_blank');

        let pollTimer = window.setInterval(function() {
            if (win.closed !== false) { // !== is required for compatibility with Opera
                window.clearInterval(pollTimer);
                window.location.reload();
            }
        }, 200);
    };
    return (
        <Button
            variant="outlined"
            color="neutral"
            size="sm"
            sx={theme => ({
                // mr: 2,
                bgcolor: 'background.surface',
                transition: 'all .2s linear',
                // bgcolor: theme.palette.danger[100],// 'background.palette.danger'
                // borderColor: theme.palette.danger[200],
                ':hover': {
                    color: 'white',
                    '--Icon-color': 'white',
                    bgcolor: theme.palette.success[500],
                    borderColor: theme.palette.success[600],
                },
                // ...additionalSx(theme, sx),
            })}
            startDecorator={<VerifiedUserRoundedIcon/>}
            /*
            component={'a'}
            href={connectableAccounts[type].connectUrl}
            target="_blank"
            */
            onClick={onClick}
        >
            Connect
        </Button>
    )
}

function DisconnectButton({type}) {
    const [loading, setLoading] = useState(false);
    const { connectedAccounts, setConnectedAccounts } = useTenant();

    const onDisconnect = () => {
        setLoading(true);
        authenticatedApi.delete('/install-settings/connected-accounts', {
            data: {account_type: type}
        }).then(() => {
            let newAccounts = {...connectedAccounts};
            delete newAccounts[type];
            setConnectedAccounts(newAccounts);

        }).finally(() => {
            setLoading(false);
        });
    };

    return (
        <WarningDialog
            title="Confirm Disconnect"
            content={<>Are you sure you want to disconnect {connectableAccounts[type].name}?</>}
            confirmText="Disconnect"
            onConfirm={onDisconnect}
            activateButton={(btnProps)=>
                <Button
                    variant="outlined"
                    color="neutral"
                    size="sm"
                    sx={theme => ({
                        // mr: 2,
                        bgcolor: 'background.surface',
                        transition: 'all .2s linear',
                        // bgcolor: theme.palette.danger[100],// 'background.palette.danger'
                        // borderColor: theme.palette.danger[200],
                        ':hover': {
                            color: 'white',
                            '--Icon-color': 'white',
                            bgcolor: theme.palette.danger[500],
                            borderColor: theme.palette.danger[600],
                        },
                        // ...additionalSx(theme, sx),
                    })}
                    startDecorator={<GppBadRoundedIcon/>}
                    {...btnProps}
                        loading={loading}
                >
                    Disconnect
                </Button>
            }
        />
    );


    return (
        <Tooltip title="Disconnect">
            <IconButton
            variant="solid"
            color="danger"
            size="sm"
            // startDecorator={<ClearRoundedIcon/>}
            >
            <ClearRoundedIcon/>
            {/* Disconnect */}
        </IconButton>
        </Tooltip>
    )
}

function IntegrationField({type}) {
    const { tenant, setTenant, connectedAccounts } = useTenant();

    const findIntegration = connectedAccounts?.[type];//.find(acct => acct.account_type === type);
    let status = findIntegration?.status ?? false;

    return (
        <Stack
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
        >
        <Box>
            <Alert
                variant="plain"
                color={status ? (status === 'connected' ? 'success' : 'danger') : 'neutral'}
                // startDecorator={<GppBadRoundedIcon />}
                startDecorator={status ? (status === 'connected' ? <CheckRoundedIcon/> : <ClearRoundedIcon/>) : null}
                sx={{p: 0, bgcolor: 'transparent', fontWeight: 'bold'}}
            >
            {status === 'connected' && (<>Connected</>)}
            {status === 'broken' && (<>Broken</>)}
            {!status && (<>Not Connected</>)}
          </Alert>
        </Box>
        <Box>
            {!!status && (<DisconnectButton type={type}/>)}
            {!status && (<ConnectButton type={type}/>)}
        </Box>
        </Stack>
    );
}

const connectedAccountsFields = (loading) => ([
    {
        type: 'info',
        label: 'Mailchimp',
        content: loading ? <MaestroLoader/> : <IntegrationField type="mailchimp"/>
    },
    {
        type: 'info',
        label: 'Constant Contact',
        content: loading ? <MaestroLoader/> : <IntegrationField type="constant_contact"/>
    },
    // coordinating program?
    /*
    {
        type: 'submit',
        label: false,
        buttonLabel: 'Update Connected Accounts',
    },
    */
]);

export default function OrganizationSettings() {
    useDocumentTitle(`Organization Settings | Maestro Community Manager`);

    const { tenant, setTenant, getConnectedAccounts } = useTenant();
    const uploadUrl = `${apiUrl}installs/${tenant.id}/logo`;// `${apiUrl}${endpoint}/${id ?? 0}/files`;

    return (
        <Uploady
            // multiple
            grouped={false} // keep this false (used for determining our pending file upload count)
            maxGroupSize={1} // keep this 1 (used for determining our pending file upload count)
            method="POST"
            destination={{ url: uploadUrl }}
            autoUpload={false}
            clearPendingOnAdd={true}
        >
            <OrganizationSettingsInner/>
        </Uploady>
    );
}

function OrganizationSettingsInner() {
    const { tenant, setTenant, getConnectedAccounts } = useTenant();
    const [loadingConnected, setLoadingConnected] = useState(true);

    // the token is read per request; reading it once at module scope freezes
    // whatever value existed when the bundle loaded
    useRequestPreSend(({ options }) => ({
        options: {
            destination: {
                ...options.destination,
                headers: {
                    ...options.destination?.headers,
                    Authorization: `Bearer ${getAccessToken()}`,
                },
            },
        },
    }));

    useEffect(() => {
        getConnectedAccounts().then(() => setLoadingConnected(false));
    }, []);

    const formMethods = useForm({
        defaultValues: {
            ...tenant,
            has_new_logo: 'no',
            // state: tenant.state_
        },
    });
    const {
        getValues,
        setValue,
        trigger,
        reset,
        handleSubmit,
        formState: { isSubmitting, errors }
    } = formMethods;

    useBatchAddListener((batch, options) => {
        setValue('has_new_logo', 'yes'); // trigger validation to show dirty
        trigger();
    });

    useItemFinishListener((item, options) => {
        let newTenantValue = {
            ...tenant,
            logo_url: item.uploadResponse?.data?.logo_url,
        };

        setTenant(newTenantValue);
        // setValue('logo_url', item.uploadResponse?.data?.logo_url);
        reset(newTenantValue);
    });

    const uploady = useUploady();
    const onSubmit = (fields) => {
        const {
            name, url, admin_email,
            address, address_2, country, postal, city, state,
            conductors, board_size, financial_structure, fiscal_year_start,
        } = fields;
        const performUpdate = authenticatedApi.put(`/installs/${tenant.id}`, {
            name, url, admin_email,
            address, address_2, country, postal, city, state,
            conductors, board_size, financial_structure, fiscal_year_start,
        });
        toast.promise(performUpdate, {
            loading: `Saving...`,
            success: `Your settings were saved!`,
            error: (err) => /*err?.response?.data?.message?.includes('Duplicate entry') ? 'This email address is already in use.' :*/ `There was an error while saving.`,
        });
        performUpdate.then(() => {
            let newTenantValue = {
                ...tenant,
                name, url, admin_email,
                address, address_2, country, postal, city, state,
                conductors, board_size, financial_structure, fiscal_year_start,
            };

            setTenant(newTenantValue);
            // setValue('logo_url', item.uploadResponse?.data?.logo_url);
            reset(newTenantValue);
        });

        uploady.processPending();
    };
    const orgInfo = {};

    return (<>
        <Subheader
            title={'Organization Settings'}
            tint={'default'}
        >
        </Subheader>

        <Box sx={theme => ({
            // backgroundImage: `linear-gradient(180deg, ${theme.palette['default'][100]} 0%, white 100%);`,// : null,
            backgroundAttachment: 'fixed',
            minHeight: 'calc(100% - var(--Header-height))',
            p: 2,
        })}>
            <form onSubmit={handleSubmit(onSubmit)} initialData={orgInfo}>
                <FormProvider {...formMethods}>
                    <Grid container columns={12} gap={2}>
                        <ObjectColumn>
                            <ObjectPrimaryInfoEdit
                                title={'Community'}
                                tint={'default'}
                                fields={communityFields}
                            />
                        </ObjectColumn>
                        <ObjectColumn>
                            <ObjectPrimaryInfoEdit
                                title={'Connected Accounts'}
                                tint={'default'}
                                fields={connectedAccountsFields(loadingConnected)}
                            />
                        </ObjectColumn>
                    </Grid>
                </FormProvider>
            </form>
                    {/*
                    <Form onSubmit={onSubmitAccountInfo} initialData={user}>
                        <ObjectPrimaryInfoEdit
                            title={'Update Account Info'}
                            tint={'default'}
                            fields={accountInfoFields}
                        />
                    </Form>
                    */}
                {/* </ObjectColumn> */}
                {/* <ObjectColumn> */}
                    {/* <UpdateEmailPreferencesBox/> */}
                {/* </ObjectColumn> */}
            {/* </Grid> */}
        </Box>
    </>);
};